import { Soup, Receipt, Stethoscope, Wallet } from "lucide-react";

const SERVICES = [
  { icon: Soup, text: "Napi / Heti meleg étkeztetés & bevásárlás" },
  { icon: Receipt, text: "Háztartási segítség & ügyintézés (csekkek, gyógyszerek szerezése)" },
  { icon: Stethoscope, text: "Orvosi vizsgálatokra való kísérés & odafigyelés" },
  { icon: Wallet, text: "Havi fix életjáradék vagy teljes körű rezsimentesítés" },
];

const IMAGES = [
  {
    src: "https://images.unsplash.com/photo-1759689975472-c302b63b3b71?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    alt: "Frissen tálalt meleg leves",
    caption: "Meleg ebéd az asztalon",
    cls: "col-span-2 aspect-[16/9]",
  },
  {
    src: "https://images.unsplash.com/photo-1599819055803-717bba43890f?crop=entropy&cs=srgb&fm=jpg&q=80&w=700",
    alt: "Friss kenyér papírzacskóban",
    caption: "Bevásárlás",
    cls: "aspect-[3/4]",
  },
  {
    src: "https://images.unsplash.com/photo-1586324304780-c9a5031a3599?crop=entropy&cs=srgb&fm=jpg&q=80&w=700",
    alt: "Egymás kezét fogó idős és fiatalabb kéz",
    caption: "Odafigyelés",
    cls: "aspect-[3/4]",
  },
];

export const CareSection = () => (
  <section id="segitseg" data-testid="care-section" className="bg-ivory text-navy py-24 md:py-32">
    <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-[240px_1fr] gap-12">
      <div className="min-w-0">
        <p className="text-base uppercase tracking-[.14em] font-semibold text-sage">Mindennapok</p>
        <h2 className="disp uppercase mt-4" style={{ fontSize: "clamp(32px,4vw,56px)", lineHeight: 1.1 }}>
          Miben segítünk nap mint nap?
        </h2>
      </div>
      <ol className="min-w-0 divide-y-2 divide-navy/15 border-y-2 border-navy/15">
        {SERVICES.map(({ icon: Icon, text }, i) => (
          <li key={text} data-testid={`care-item-${i + 1}`} className={`fu c${i + 1} group grid grid-cols-[auto_1fr] gap-6 md:gap-8 items-center py-8`}>
            <span className="flex h-14 w-14 md:h-16 md:w-16 items-center justify-center border-2 border-navy transition-colors group-hover:bg-coral group-hover:border-coral">
              <Icon className="h-7 w-7 md:h-8 md:w-8 text-burgundy group-hover:text-coral-ink" strokeWidth={1.75} />
            </span>
            <span className="text-xl md:text-2xl font-semibold">{text}</span>
          </li>
        ))}
      </ol>
    </div>
    <div className="max-w-6xl mx-auto px-6 mt-24 grid grid-cols-2 md:grid-cols-4 gap-6">
      {IMAGES.map((img) => (
        <figure key={img.caption} className={`relative overflow-hidden bg-sand ${img.cls}`}>
          <img src={img.src} alt={img.alt} loading="lazy" className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 hover:scale-105" />
          <figcaption className="absolute left-4 bottom-4 bg-ivory px-3 py-1 text-sm uppercase tracking-[.14em] text-umber font-semibold">
            {img.caption}
          </figcaption>
        </figure>
      ))}
    </div>
  </section>
);
